import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import * as ActionType from "../../store/hostRequest/hostRequest.type";
// mui
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Tooltip,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import Cancel from "@mui/icons-material/Cancel";
import { hostRequestUpdate } from "../../store/hostRequest/hostRequest.action";

import femaleImage from "../../assets/img/female.png";
import maleImage from "../../assets/img/maleImage.png";
import $ from "jquery"


const HostRequestEdit = (props) => {
  const { dialog: open, dialogData } = useSelector(
    (state) => state.hostRequest
  );
  

  

  const [name, setName] = useState("");

  const [bio, setBio] = useState("");
  const [dob, setDob] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [video, setVideo] = useState([]);
  const [videoPath, setVideoPath] = useState("");

  const [error, setError] = useState({
    name: "",
    password: "",
    bio: "",
    dob: "",
    mobileNumber: "",
    image: "",
    gender: "",
    email: "",
    oldAgency: "",
    country: "",
    video: "",
  });

  useEffect(() => {
    if (dialogData) {
      setName(dialogData?.name);
      setEmail(dialogData?.email && dialogData?.email.toLowerCase() !== "flirtzy@gmail.com" ? dialogData?.email : "");
      setCountry(dialogData?.country);
      setDob(dialogData?.dob || "");
      setGender(dialogData?.gender);
      setBio(dialogData?.bio);
      setImagePath(dialogData?.image);
      setVideoPath(dialogData?.video);
      setMobileNumber(dialogData?.mobileNumber);
      setError({
        name: "",
        dob: "",
        mobileNumber: "",
        country: "",
        email: "",
        image: "",
        gender: "",
        bio: "",
        video: "",
      });
    }
  }, [dialogData]);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
  };

  const handleVideo = (e) => {
    setVideo(e.target.files[0]);
    setVideoPath(URL.createObjectURL(e.target.files[0]));
  };
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({ type: ActionType.CLOSE_HOST_REQUEST_DIALOG });
  };
  useEffect(() => {
    window.onbeforeunload = handleClose();
  }, []);
  const handleSubmit = () => {
    if (
      !name ||
      !bio ||
      !dob ||
      !mobileNumber ||
      !gender ||
      !email ||
      !country ||
      !imagePath ||
      !videoPath
    ) {
      let error = {};
      if (!name) error.name = "Name Is Required!";
      if (!email) error.email = "Email Is Required!";
      if (!gender) error.gender = "Gender Is Required!";
      if (!dob) error.dob = "DOB Is Required!";
        if (!mobileNumber) error.mobileNumber = "Mobile Number Is Required!";
      if (!country) error.country = "Country Is Required!";
      if (!imagePath) error.image = "Image Is Required!";
      if (!videoPath) error.video = "video Is Required!";
      return setError({ ...error });
    } else {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("dob", dob);
      formData.append("mobileNumber", mobileNumber);
      formData.append("country", country);
      formData.append("image", image);
      formData.append("video", video);
      formData.append("email", email);
      formData.append("gender", gender);
      formData.append("bio", bio);
       
      props.hostRequestUpdate(formData, dialogData._id);

      handleClose();
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
    // set default image

    
  return (
    <Dialog
      open={open}
      aria-labelledby="responsive-dialog-title"
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        id="responsive-dialog-title"
        className="dialogue_background_color"
      >
        <span className="modal-title font-weight-bold h4"> Host Request </span>
      </DialogTitle>

      <IconButton
        style={{
          position: "absolute",
          right: 0,
        }}
      >
        <Tooltip title="Close">
          <Cancel className="modal-title" onClick={handleClose} />
        </Tooltip>
      </IconButton>

      <DialogContent className="dialogue_background_color">
        <div className="row">
          <div className="col-6">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Name </p>
              </div>
              <input
                type="text"
                placeholder="Name"
                className="form-control"
                autocomplete="off"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (!e.target.value)
                    return setError({
                      ...error,
                      name: "Name Is Required !",
                    });
                  else {
                    return setError({
                      ...error,
                      name: "",
                    });
                  }
                }}
                onKeyPress={handleKeyPress}
              />
              {error.name && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.name}
                  </Typography>
                </div>
              )}
            </div>
          </div>

          <div className="col-6">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Email </p>
              </div>
              <input
                type="text"
                min="0"
                placeholder="Email"
                className="form-control pe-1"
                autocomplete="off"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (!e.target.value)
                    return setError({
                      ...error,
                      email: "Email  Is Required !",
                    });
                  else {
                    return setError({
                      ...error,
                      email: "",
                    });
                  }
                }}
                onKeyPress={handleKeyPress}
              />
              {error.email && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.email}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div>
              <div>
                <div className="form-group mb-0">
                  <p className="form-label fw-bold mt-3"> Bio</p>
                </div>
                <input
                  type="text"
                  placeholder="Bio"
                  value={bio}
                  className="form-control "
                  autocomplete="off"
                  onChange={(e) => {
                    setBio(e.target.value);
                    if (!e.target.value)
                      return setError({
                        ...error,
                        bio: "Bio Is Required !",
                      });
                    else {
                      return setError({
                        ...error,
                        bio: "",
                      });
                    }
                  }}
                  onKeyPress={handleKeyPress}
                />
              </div>
              {error.bio && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.bio}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div>
              <div>
                <div className="form-group mb-0">
                  <p className="form-label fw-bold mt-3"> DOB</p>
                </div>
                <input
                  type="text"
                  placeholder="DOB"
                  value={dob}
                  className="form-control pe-1"
                  autocomplete="off"
                  onChange={(e) => {
                    setDob(e.target.value);
                    if (!e.target.value)
                      return setError({
                        ...error,
                        dob: "DOB Is Required !",
                      });
                    else {
                      return setError({
                        ...error,
                        dob: "",
                      });
                    }
                  }}
                  onKeyPress={handleKeyPress}
                />
              </div>
              {error.dob && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.dob}
                  </Typography>
                </div>
              )}
            </div>
          </div>
          <div className="col-6">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Mobile No</p>
              </div>
              <input
                type="text"
                placeholder="Mobile No"
                value={mobileNumber}
                className="form-control pe-1"
                autocomplete="off"
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  if (!e.target.value)
                    return setError({
                      ...error,
                      mobileNumber: "Mobile Number Is Required !",
                    });
                  else {
                    return setError({
                      ...error,
                      mobileNumber: "",
                    });
                  }
                }}
                onKeyPress={handleKeyPress}
              />
              {error.mobileNumber && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.mobileNumber}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Country</p>
              </div>
              <input
                className="form-control"
                placeholder="Country"
                type="text"
                value={country}
                onChange={(e) => {
                  setCountry(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      country: "Country Is Required !",
                    });
                  } else {
                    return setError({
                      ...error,
                      country: "",
                    });
                  }
                }}
                onKeyPress={handleKeyPress}
              />
            </div>
            {error.country && (
              <div class="pl-1 text-left">
                <Typography
                  variant="caption"
                  color="error"
                  style={{ fontFamily: "Circular-Loom" }}
                >
                  {error.country}
                </Typography>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <p className="form-label fw-bold mt-3 "> Gender</p>
            <FormControl className="mb-0">
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={gender?.toLowerCase()}
                onChange={(e) => {
                  setGender(e.target.value);
                  if (!e.target.value)
                    return setError({
                      ...error,
                      gender: "Gender Is Required !",
                    });
                  else {
                    return setError({
                      ...error,
                      gender: "",
                    });
                  }
                }}
              >
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Male"
                />
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Female"
                        />
                        <FormControlLabel
                          value="Other"
                          control={<Radio />}
                          label="Other"
                        />
              </RadioGroup>
            </FormControl>
            {error.gender && (
              <div class="pl-1 text-left">
                <Typography
                  variant="caption"
                  color="error"
                  style={{ fontFamily: "Circular-Loom" }}
                >
                  {error.gender}
                </Typography>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-6 my-2">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Host Image</p>
              </div>
              <input
                type="file"
                accept="image/*"
                className="form-control "
                autocomplete="off"
                onChange={(e) => handleImage(e)}
                onKeyPress={handleKeyPress}
              />
              {imagePath && (
                <img
                  src={imagePath}
                  alt="hostImage"
                  draggable="false"
                  className="p-3 dialogueImageVideoShow"
                  width={100}
                />
              )}
              {error.image && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.image}
                  </Typography>
                </div>
              )}
            </div>
          </div>

          <div className="col-6">
            <div>
              <div className="form-group mb-0">
                <p className="form-label fw-bold mt-3"> Host Video</p>
              </div>
              <input
                type="file"
                accept="video/*"
                className="form-control "
                autocomplete="off"
                onChange={(e) => handleVideo(e)}
                onKeyPress={handleKeyPress}
              />
              {videoPath && (
                <video
                  autoPlay
                  loop
                  src={videoPath}
                  alt="hostImage"
                  draggable="false"
                  className="p-3 dialogueImageVideoShow"
                  width={100}
                />
              )}
              {error.image && (
                <div class="pl-1 text-left">
                  <Typography
                    variant="caption"
                    color="error"
                    style={{ fontFamily: "Circular-Loom" }}
                  >
                    {error.image}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="dialogue_background_color">
        <button
          type="button"
          className="btn  btn-success my-3"
          onClick={handleSubmit}
          style={{ fontSize: "15px" }}
        >
          Update
        </button>
        <button
          type="button"
          className="btn  btn-danger my-3"
          onClick={handleClose}
          style={{ fontSize: "15px" }}
        >
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(null, { hostRequestUpdate })(HostRequestEdit);
